import {
  Component,
  Input,
  OnInit,
  AfterViewInit,
} from '@angular/core';

@Component({
  selector: 'sd-label',
  templateUrl: './label.component.html',
})

export class LabelComponent implements OnInit, AfterViewInit {
  @Input() label: string;
  @Input() icon: string;
  @Input() fontSet: 'material-icons' |
    'material-icons-outlined' |
    'material-icons-outlined' |
    'material-icons-round' |
    'material-icons-sharp' = 'material-icons';
  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }
}
